module.exports = __webpack_public_path__ + "images/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./images/favicon.ico
// module id = 1113
// module chunks = 1